import Vue from 'vue';
import Vuex from 'vuex';

import {
  getRedPointList,
} from '@api/ingame';
import {
  getUserProfile,
  getPointTaskList,
} from '@api/point';
import { getMossBannerById, getInfoProviderById } from '@api/json';
import { getUnreadMessageNums } from '@api/messagecenter';
import {
  shuffle,
  copy,
  isNotEmpty,
  isEmpty,
} from '@tencent/slug-function';
import {
  getRedPointSum,
  getRedPointClickLocal,
  setRedPointClickLocal,
} from '@utils';
import { tokenObj } from '../js/tokenParams.js';

// 攻略红点
const redPoints = async () => {
  const { data: { num: msg } } = (await getUnreadMessageNums('1050001|1070002'));
  const r = {
    pub: 0,
    myGood: 0,
    msg,
  };
  return {
    ...r,
    sum: r.pub + r.myGood + msg,
  };
};

const dayjs = require('dayjs');
const isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);

Vue.use(Vuex);

const store = {
  state: {
    tokenObj,
    // note: 用户关注数和粉丝数
    userInfo: {},
    fansCount: 0,
    userAttr: '',
    followCount: 0,
    pageTitleName: '',
    pageTitle: '',
    // note: userid: 这里是后端中的对 openid 加密的数据， 由于 user_info 接口中无法获取到用户的 user_id, 故这里从 动态数据中获取本身的 userid
    userId: '',
    // // 动态置顶， 删除
    // showOperateConfirmDialog: false,
    // 用户属性编辑
    showEditUserAttributeDialog: false,

    // 游戏nickname
    nickName: '',
    // 首页
    ads: {}, // 广告对象
    seeSet: [],

    evBodysWatch: [], // 大家都在看
    keywords: [],
    isFocus: true,
    hotKeyWords: [], // 热搜关键字列表
    keyword: '',
    hotKeyWord: '', // 热搜关键字
    searchHistory: [], // 搜索历史记录
    strategyStates: {
      limit: 8,
      loading: false,
      noMore: false,
      curPage: 0,
    },

    maps: {}, // 地图数据
    mapsStrategyPoint: {}, // 地图点位攻略数据

    // 红点
    redPoint: {
      // 攻略模块
      walkthrough: {
        // 精选
        selected: {
          type: 'general',
          num: 0,
        },
        // 新版本任务
        'edition-news': {
          type: 'general',
          num: 0,
        },
      },
      // 福利模块
      welfare: {
        // 马拉松
        marathon: {
          type: 'general',
          num: 0,
        },
        // 积分站
        point: {
          type: 'general',
          num: 0,
        },
        // 主题玩法福利站
        ipbd: {
          type: 'general',
          num: 0,
        },
      },
      // 我的模块
      mine: {
        msg: {
          type: 'general',
          num: 0,
        },
      },
    },
    // music
    music: {
      isPause: false, // 音乐播放状态
      isShow: -1, // 精选音乐outline
      isPlay: -1, // 精选音乐icon
      currentMusic: { data: 1, play: 1 }, // 当前音乐播放数据
      musicIndex: 0, // 当前音乐播放下标
      musicUrl: [], // 音乐列表
      musicPage: 1, // 音乐页码
      requestEnableMusicList: true, // 是否允许加载后续音乐
    },

    // 大事件tab
    eventSideBarList: [],
    eventCurSideBar: null,
    eventId: null,

    // 武器库资料库
    hasLoadGlequipmentList: false,
    glequipmentList: { wqList: [], pjList: [], wzList: [], zjList: [] },

    // 个人数据开关
    showGameInfo: true,
    hasGetShowGameInfo: false,
  },
  getters: {
    getCommonPageTitle(state) {
      return state.pageTitle;
    },
    getCommonPageName(state) {
      return state.pageTitleName;
    },
    // 获取用户的关注信息
    getUserFollowAndFansInfo(state) {
      const { followCount, fansCount } = state;
      return { followCount, fansCount };
    },
    // 攻略侧边tab红点统计
    redPointWalkthroughSum(state) {
      return getRedPointSum(state.redPoint.walkthrough);
    },
    // 福利侧边tab红点统计
    redPointWelfareSum(state) {
      return getRedPointSum(state.redPoint.welfare);
    },
    // 我的侧边tab红点统计
    redPointMineSum(state) {
      return getRedPointSum(state.redPoint.mine);
    },
    // 顶部一级tab红点统计，字段命名使用 nav-list 的 targetRouterName
    redPointTopTab(state) {
      return {
        // 攻略 - 精选 tab
        index: getRedPointSum(state.redPoint.walkthrough, ['selected']),
        // 攻略 - 版本爆料 tab
        edition: getRedPointSum(state.redPoint.walkthrough, [
          'edition',
          'edition-news',
        ]),
        // 福利 - 常驻福利 tab
        welfare: getRedPointSum(state.redPoint.welfare, ['point', 'ipbd']),
        // 我的 - 个人主页 tab
        mythumbup: getRedPointSum(state.redPoint.mine, ['msg']),
      };
    },
    // 顶部二级tab红点统计，字段命名使用 nav-list 的 targetRouterName
    redPointSubTab(state) {
      return {
        // 攻略 - 版本爆料 - 版本时间轴
        edition: getRedPointSum(state.redPoint.walkthrough, ['edition']),
        // 攻略 - 版本爆料 - 版本任务
        'edition-news': getRedPointSum(state.redPoint.walkthrough, [
          'edition-news',
        ]),
        // 我的 - 个人主页 - 我的消息 tab
        mymsg: getRedPointSum(state.redPoint.mine, ['msg']),
      };
    },
  },
  actions: {
    // 设置点击后的红点数值，更新store并存储已点击到localStorage（适用于普通红点，点一次即消失）
    setRedPoint({ commit }, { module, key, value }) {
      setRedPointClickLocal({
        module,
        key,
      });
      commit('SET_RED_POINT', {
        module,
        key,
        value,
      });
    },

    // 初始化获取红点
    initGetRedPoint({ dispatch }) {
      dispatch('getWalkthroughRedPoint');
      dispatch('getWelfareRedPoint');
      dispatch('getMineRedPoint');
    },

    // 获取攻略模块红点
    getWalkthroughRedPoint({ commit }) {
      // 精选 红点 今日是否点击过
      const selectedIsClicked = getRedPointClickLocal(
        {
          module: 'walkthrough',
          key: 'selected',
        },
        true,
      );
      if (selectedIsClicked) {
        commit('SET_RED_POINT', {
          module: 'walkthrough',
          key: 'selected',
          value: 0,
        });
      } else {
        commit('SET_RED_POINT', {
          module: 'walkthrough',
          key: 'selected',
          value: 1,
        });
      }
      // dispatch('getEditionRedPoint');
      // TODO: 版本爆料红点
      // dispatch('getEditionTaskRedPoint');
    },

    // 获取福利模块红点
    async getWelfareRedPoint({ commit }) {
      try {
        const { data: { redPoint } } = await getRedPointList();

        // 积分站 红点
        const pointRedPoint = redPoint.find(item => item.redKey === 'gp_point_gain');
        if (isNotEmpty(pointRedPoint)) {
          let pointNum = Number(pointRedPoint.redValue);
          // 存在未完成的任务且积分值和大于X  + 存在可待领取的积分时，都有红点。X为10
          if (pointNum <= 10) {
            pointNum = 0;
          }
          commit('SET_RED_POINT', {
            module: 'welfare',
            key: 'point',
            value: pointNum,
          });
        }

        // 马拉松 红点
        const marathonRedPoint = redPoint.find(item => item.redKey === 'gp_marathon');
        if (isNotEmpty(marathonRedPoint)) {
          commit('SET_RED_POINT', {
            module: 'welfare',
            key: 'marathon',
            value: Number(marathonRedPoint.redValue),
          });
        }

        // 主题玩法福利站 红点
        const ipbdRedPoint = redPoint.find(item => item.redKey === 'gp_fuli_luck');
        const ipbdRedPointIsClicked = getRedPointClickLocal(
          {
            module: 'welfare',
            key: 'ipbd',
          },
          true,
        );
        // 今天是否点击过
        if (ipbdRedPointIsClicked || isEmpty(ipbdRedPoint)) {
          commit('SET_RED_POINT', {
            module: 'welfare',
            key: 'ipbd',
            value: 0,
          });
        } else {
          commit('SET_RED_POINT', {
            module: 'welfare',
            key: 'ipbd',
            value: Number(ipbdRedPoint.redValue),
          });
        }
      } catch (error) {
        commit('SET_RED_POINT', {
          module: 'welfare',
          value: 0,
        });
      }
    },

    // 获取我的模块红点
    async getMineRedPoint({ commit }) {
      try {
        // 获取我的消息红点
        const { msg } = await redPoints();
        commit('SET_RED_POINT', {
          module: 'mine',
          key: 'msg',
          value: msg,
        });
      } catch (error) {
        commit('SET_RED_POINT', {
          module: 'mine',
          key: 'msg',
          value: 0,
        });
      }
    },

    // 获取版本爆料红点
    /* async getEditionRedPoint({ commit }) {
      // 本地存储的最后查看版本
      const lastViewVersion = getLocal('lastViewVersion');
      let versionReportData = await getEditionReport() || [];
      versionReportData = versionReportData
        .filter(item => dayjs().isAfter(dayjs(item.start_time)))
        .sort((left, right) => {
          if (dayjs(left.start_time).isAfter(dayjs(right.start_time))) {
            return -1;
          }
          return 1;
        }) || [];
      // 最新爆料版本
      const [lastVersion] = versionReportData;
      if (lastViewVersion) {
        const lastViewVerStartTime = lastViewVersion.start_time || '';
        if (lastVersion) {
          const lastVerStartTime = lastVersion.start_time || '';
          if (dayjs(lastVerStartTime).isAfter(dayjs(lastViewVerStartTime))) {
            commit('SET_RED_POINT', { module: 'walkthrough', key: 'edition', value: 1 });
          } else {
            commit('SET_RED_POINT', { module: 'walkthrough', key: 'edition', value: 0 });
          }
        }
      } else if (lastVersion) {
        commit('SET_RED_POINT', { module: 'walkthrough', key: 'edition', value: 1 });
        // setLocal('lastViewVersion', lastVersion);
      }
    }, */

    // 获取版本爆料任务红点
    async getEditionTaskRedPoint({ commit }) {
      // commit('SET_RED_POINT', { module: 'walkthrough', key: 'edition-news', value: 1 });
      let { data: taskConfig } = await getInfoProviderById(1448);
      taskConfig = taskConfig
        .filter(item => dayjs().isBetween(item.startTime, item.endTime))
        .sort((a, b) => a.sort - b.sort);

      const wxSiteId = taskConfig[0] && taskConfig[0].describe;
      const qqSiteId = taskConfig[1] && taskConfig[1].describe;
      let siteId = qqSiteId;

      if (tokenObj.openid && /[a-z]/.test(tokenObj.openid)) {
        siteId = wxSiteId;
      }
      // })
      const { data: taskListRes } = await getPointTaskList({ site_id: siteId });
      const taskList = taskListRes.items || [];
      const totalTaskNum = taskList.length;
      const finishTaskNum = taskList.filter(item => item.taskStatus === 2)
        .length;
      let taskPointAmount = 0;
      taskList.forEach((item) => {
        taskPointAmount += item.pointAmount;
      });

      const { data: counterObj } = await getUserProfile(siteId);
      const counter = counterObj && counterObj.user && counterObj.user.pointBalance;

      // 新配置、一个任务都未完成
      if (totalTaskNum > 0 && finishTaskNum === 0) {
        commit('SET_RED_POINT', {
          module: 'walkthrough',
          key: 'edition-news',
          value: 1,
        });
      }
      // 可领取奖励，显示红点
      if (
        totalTaskNum > 0
        && totalTaskNum === finishTaskNum
        && counter >= taskPointAmount
      ) {
        commit('SET_RED_POINT', {
          module: 'walkthrough',
          key: 'edition-news',
          value: 1,
        });
      }
    },

    async mustSee({ commit, state }) {
      let seeSet = [];
      if (state.seeSet.length === 0) {
        const { data } = await getMossBannerById(88);
        seeSet = data;
        window.gpIngameData && (window.gpIngameData.seeSet = seeSet);
        const tops = []; // 置顶的
        let other = []; // 非置顶的
        let final = []; // 最终的
        // 判断是否为今天首次进入 lastJoinTime 第一次进入存入今天的最后一秒
        // 如果数据更新了或者是今天第一次进入
        if (
          !localStorage.lastUpdatedMustSee
          || JSON.stringify(seeSet) !== localStorage.lastUpdatedMustSee
          || !localStorage.lastJoinTime
          || Number.parseInt(localStorage.lastJoinTime, 10) < new Date().getTime()
        ) {
          console.log('更新了！');
          localStorage.setItem('lastUpdatedMustSee', JSON.stringify(seeSet));
          localStorage.setItem(
            'lastJoinTime',
            new Date().setHours(0, 0, 0, 0) + 86400000,
          );
          const arr = copy(seeSet, -1);
          // 根据 sort 字段， 降序排列
          arr.sort((a, b) => parseInt(b.sort, 10) - parseInt(a.sort, 10));

          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].sort > 0 && tops.length < 10) {
              tops.push(arr[i]);
            } else {
              other.push(arr[i]);
            }
          }
          other = shuffle(other); // 随机非置顶的
          final = tops.slice(0, 5);
          final = final.concat(other.splice(0, 10 - final.length));
          final = final.concat(
            tops.slice(5, 10),
            other.splice(0, 20 - final.length),
          );
          localStorage.setItem('seeSet', JSON.stringify(final));
        } else {
          console.log('缓存！');
          final = JSON.parse(localStorage.seeSet);
        }

        commit('SET_STATE', {
          key: 'seeSet',
          value: final,
        });
      }
    },

    async getMaps({ commit, state }, id) {
      try {
        const tempMaps = state.maps;
        if (!tempMaps[`m${id}`]) {
          const { data } = await getMossBannerById(id);
          tempMaps[`m${id}`] = data;
          commit('SET_STATE', {
            value: {},
            key: 'maps',
          });
          commit('SET_STATE', {
            value: tempMaps,
            key: 'maps',
          });
        }
      } catch (err) {
        console.log('prefech error:', err);
      }
    },

    async getMapsStrategyPoint({ commit, state }, id) {
      try {
        const tempMaps = state.mapsStrategyPoint;
        if (!tempMaps[id]) {
          const { data } = await getInfoProviderById(id);
          tempMaps[`m${id}`] = data;
          commit('SET_STATE', {
            value: {},
            key: 'mapsStrategyPoint',
          });
          commit('SET_STATE', {
            value: tempMaps,
            key: 'mapsStrategyPoint',
          });
        }
      } catch (err) {
        console.log('prefech error:', err);
      }
    },

    /**
     * 获取大家都在看
     * @return {Promise<void>}
     */
    async getEvBodysWatch({ commit, state }) {
      let { evBodysWatch } = state;

      try {
        if (evBodysWatch.length < 1) {
          const { data } = await getMossBannerById(478);
          evBodysWatch = data;
          commit('SET_STATE', {
            value: {},
            key: 'evBodysWatch',
          });
          commit('SET_STATE', {
            value: evBodysWatch,
            key: 'evBodysWatch',
          });
        }
        commit('SET_STATE', {
          value: {},
          key: 'keywords',
        });
        // 打乱数组并且取前5个
        commit('SET_STATE', {
          value: shuffle(evBodysWatch).slice(0, 5),
          key: 'keywords',
        });
      } catch (err) {
        console.log('prefech error:', err);
      }
    },

    /**
     * 获取热搜关键字
     * @return {Promise<void>}
     */
    async getHotSearchKeyWord({ commit, state }) {
      let { hotKeyWords } = state;

      try {
        if (hotKeyWords.length < 1) {
          const { data } = await getMossBannerById(953);
          hotKeyWords = data;
          commit('SET_STATE', {
            value: {},
            key: 'hotKeyWords',
          });
          commit('SET_STATE', {
            value: hotKeyWords,
            key: 'hotKeyWords',
          });
          commit('SET_STATE', {
            value: {},
            key: 'hotKeyWord',
          });
          commit('SET_STATE', {
            value: shuffle(hotKeyWords)[0], // 打乱数组并且取第一个
            key: 'hotKeyWord',
          });
        }
      } catch (err) {
        console.log('prefech error:', err);
      }
    },

    /**
     * 更新搜索历史记录
     * params 数组则替换，字符串则放到第一个
     */
    updateSearchHistory({ commit, state }, params) {
      let arr = state.searchHistory;
      const type = Object.prototype.toString.call(params);
      if (type === '[object Array]') {
        arr = params;
      } else if (type === '[object String]') {
        arr.unshift(params);
        if (state.keyword !== params) {
          commit('SET_STATE', {
            value: params,
            key: 'keyword',
          });
        }
      }
      arr = Array.from(new Set(arr));
      localStorage.setItem('searchHistory', JSON.stringify(arr));
      commit('SET_STATE', {
        value: [],
        key: 'searchHistory',
      });
      commit('SET_STATE', {
        value: arr,
        key: 'searchHistory',
      });
    },

    /**
     * 更新 热搜输入框是否激活-isFocus
     */
    updateIsFocus({ commit }, params) {
      commit('SET_STATE', {
        value: params,
        key: 'isFocus',
      });
    },

    // note: 保存用户信息
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', { value: userInfo, key: 'userInfo' });
    },

    configEditUserAttributeDialog({ commit }, val) {
      commit('CONFIG_DIALOG_STATE', { value: val, key: 'showEditUserAttributeDialog' });
    },

    configOperateConfirmDialog({ commit }, val) {
      commit('CONFIG_DIALOG_STATE', { value: val, key: 'showOperateConfirmDialog' });
    },
  },

  mutations: {
    // 设置粉丝数和关注数
    SET_USER_FANS_COUNT(state, { key, value }) {
      state[key] = value || 0;
    },
    // 设置粉丝数和关注数
    SET_USER_ATTR_DATA(state, { key, value }) {
      state[key] = value || '';
    },
    SET_USER_FOLLOW_COUNT(state, { key, value }) {
      state[key] = value || 0;
    },
    // 设置 当前无导航的页面header
    SET_NORMAL_PAGE_HEADER_TITLE(state, { key, value }) {
      state[key] = value || '';
    },
    SET_NORMAL_PAGE_HEADER_NAME(state, { key, value }) {
      state[key] = value || '';
    },
    // 控制弹框显示隐藏
    CONFIG_DIALOG_STATE(state, { key, value }) {
      state[key] = value || null;
    },
    SET_USER_INFO(state, { key, value }) {
      state[key] = value || null;
    },
    // 设置自己的 userid
    SET_OWN_USERID(state, value) {
      state.userId = value;
    },
    SET_LIST(state, { key, list }) {
      state[key] = list || [];
    },
    SET_STATE(state, { key, value }) {
      state[key] = value;
    },
    // 设置红点数值，必须指定module，可指定只修改该module中的某些key或全部修改（不传key则修改该module下所有key的值）
    SET_RED_POINT(state, { module, key, value = 0 }) {
      if (isNotEmpty(key)) {
        Vue.set(state.redPoint[module][key], 'num', value);
      } else {
        for (const key in state.redPoint[module]) {
          if (
            Object.prototype.hasOwnProperty.call(state.redPoint[module], key)
          ) {
            Vue.set(state.redPoint[module][key], 'num', value);
          }
        }
      }
    },
    IS_PAUSE_MODIFY(state, value) {
      state.music.isPause = value;
    },
    IS_SHOW_MODIFY(state, value) { // 精选音乐outline
      state.music.isShow = value;
    },
    IS_PLAY_MODIFY(state, value) { // 精选音乐icon
      state.music.isPlay = value;
    },
    CURRENT_MUSIC(state, value) {
      state.music.currentMusic = value;
    },
    MUSIC_INDEX(state, value) {
      state.music.musicIndex = value;
    },
    MUSIC_URL(state, value) {
      state.music.musicUrl = value;
    },
    MUSIC_PAGE(state, value) {
      state.music.musicPage = value;
    },
    REQUEST_ENABLE_MUSIC_LIST(state, value) {
      state.music.requestEnableMusicList = value;
    },
    // 设置武器库资料库
    SET_EQUIP_LIST(state, value) {
      state.hasLoadGlequipmentList = true;
      state.glequipmentList = value;
    },
    SET_NICKNAME(state, value) {
      state.nickName = value;
    },
  },
};

export default new Vuex.Store(store);
